import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function AboutSection() {
  const stats = [{
    label: 'Años de experiencia',
    value: '15+'
  }, {
    label: 'Vehículos restaurados',
    value: '5000+'
  }, {
    label: 'Satisfacción garantizada',
    value: '100%'
  }, {
    label: 'Valoración media',
    value: '4.9★'
  }];
  const features = ['Profesionales altamente cualificados', 'Tecnología y herramientas de última generación', 'Pinturas premium de máxima durabilidad', 'Garantía en todos nuestros trabajos'];
  const galleryImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/nimjoJ3grqR5xupg1cDe7T/heylloyd-image-1774620623703.png',
    alt: 'Pintando un coche rojo en cabina profesional'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/cRngAU39Vt1d5A8yeyLqz4/heylloyd-image-1774620675613.png',
    alt: 'Pulido profesional de carrocería negra'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mDYv6S7f26FVPD68uU43UM/heylloyd-image-1774620788369.png',
    alt: 'Antes y después de pintura de coche'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mSmfYpGP1MNTTy8g1uz3Kk/heylloyd-image-1774620971975.png',
    alt: 'Lijado y preparación de paragolpes'
  }];
  return <section className="bg-[#F9FAFB] py-24 text-gray-900" data-id="element-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          {/* Text Content */}
          <div data-id="element-15">
            <div className="mb-2 inline-block" data-id="element-16">
              <h2 className="text-3xl font-bold sm:text-4xl" data-id="element-17">Quiénes Somos</h2>
              <div className="h-1 w-20 bg-red-600 mt-2 rounded-full" data-id="element-18"></div>
            </div>

            <p className="mt-6 text-lg text-gray-600 leading-relaxed" data-id="element-19">
              En <strong className="text-gray-900" data-id="element-20">Talleres Trivi</strong> somos
              apasionados del motor y perfeccionistas en nuestro trabajo. Con
              más de 15 años de experiencia en el sector, nos hemos consolidado
              como un referente en chapa y pintura en Madrid.
            </p>

            <p className="mt-4 text-lg text-gray-600 leading-relaxed" data-id="element-21">
              Nuestro objetivo es simple: devolver a tu vehículo su aspecto
              original de fábrica, o transformarlo completamente según tus
              deseos, siempre con un nivel de detalle y precisión inigualable.
            </p>

            <ul className="mt-8 space-y-4" data-id="element-22">
              {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-23">
                  <CheckCircleIcon className="h-6 w-6 text-red-600 mr-3 flex-shrink-0" data-id="element-24" />
                  <span className="text-gray-700 font-medium" data-id="element-25">{feature}</span>
                </li>)}
            </ul>
          </div>

          {/* Workshop Image */}
          <div className="relative" data-id="element-26">
            <div className="absolute -inset-4 bg-gradient-to-r from-red-600 to-red-900 rounded-2xl opacity-20 blur-lg" data-id="element-27"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] border border-gray-200" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/nimjoJ3grqR5xupg1cDe7T/heylloyd-image-1774620623703.png" alt="Profesional pintando un coche con pistola de pintura en cabina" className="w-full h-full object-cover" data-id="element-29" />
              {/* Overlay with logo */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-30"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between" data-id="element-31">
                <img src="https://cdn.magicpatterns.com/uploads/d7CGfBJVpgHPrtKLpyLsKD/TRIVI_CAMBIO_1.png" alt="Logo Trivi" className="h-12 w-auto drop-shadow-2xl" data-id="element-32" />
                <span className="text-white font-semibold text-sm tracking-wider uppercase bg-red-600/80 backdrop-blur-sm px-3 py-1 rounded-full" data-id="element-33">
                  Precisión y Arte
                </span>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-gray-100 flex items-center gap-4" data-id="element-34">
              <div className="bg-red-100 p-3 rounded-full text-red-600" data-id="element-35">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-36">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" data-id="element-37" />
                </svg>
              </div>
              <div data-id="element-38">
                <p className="text-sm text-gray-500 font-medium" data-id="element-39">Calidad</p>
                <p className="text-lg font-bold text-gray-900" data-id="element-40">Certificada</p>
              </div>
            </div>
          </div>
        </div>

        {/* Workshop Gallery Strip */}
        <div className="mt-20 mb-8" data-id="element-41">
          <h3 className="text-center text-lg font-semibold text-gray-500 uppercase tracking-wider mb-8" data-id="element-42">
            Nuestro Taller
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-43">
            {galleryImages.map((img, index) => <div key={index} className="relative rounded-xl overflow-hidden aspect-[4/3] group cursor-pointer" data-id="element-44">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-45" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" data-id="element-46"></div>
              </div>)}
          </div>
        </div>

        {/* Stats Row */}
        <div className="mt-12 grid grid-cols-2 gap-8 md:grid-cols-4 border-t border-gray-200 pt-12" data-id="element-47">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-48">
              <p className="text-4xl font-extrabold text-red-600" data-id="element-49">
                {stat.value}
              </p>
              <p className="mt-2 text-sm font-medium text-gray-600 uppercase tracking-wide" data-id="element-50">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}